/**
 *  Formats the unique id to have a length of 2
 */
export const formatUniqueId = (id: string | number) => {
  const normalizedId = id.toString();

  if (normalizedId.length > 1) return normalizedId;

  return '0' + normalizedId;
};
